module.exports = __webpack_public_path__ + "static/media/IMG_8044.f4722bae.jpg";